var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStrEth = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 28 28",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.999,
    cy: 14,
    r: 14,
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "m13.998 15.693-4.946-2.775-.134.203c-1.522 2.296-1.182 5.303.816 7.232 2.354 2.267 6.171 2.267 8.528 0 2.003-1.929 2.342-4.936.817-7.232l-.134-.203z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "m13.998 15.693-4.946-2.775-.134.203c-1.522 2.296-1.182 5.303.816 7.232 2.354 2.267 6.171 2.267 8.528 0 2.003-1.929 2.342-4.936.817-7.232l-.134-.203z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M14 21.822a4.862 4.862 0 1 0 0-9.724 4.862 4.862 0 0 0 0 9.724"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    fillOpacity: 0.9,
    d: "M14 21.822a4.862 4.862 0 1 0 0-9.724 4.862 4.862 0 0 0 0 9.724"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M14 21.092a2.749 2.749 0 1 0 0-5.498 2.749 2.749 0 0 0 0 5.498"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    fillRule: "evenodd",
    d: "m14 5.246 4.202 6.391L14 14.015l-4.202-2.378zm-2.917 6.087L14 6.9l2.917 4.434L14 12.983z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(90 0 14)scale(19.7322 19.3868)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0665fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131d52"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.02451 9.8 -12.9335 -.09303 14.15 13.653)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff2f2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#ffacac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.55809 12.9657 -17.1143 .40654 13.72 11.345)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4c91ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#a3eaff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(90 -1.48 15.48)scale(4.86213)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23164b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#15105d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#2d68c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(90 1.063 13.099)scale(4.20397)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#061458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061458",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(90 -2.171 16.172)scale(2.74875)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bb2354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#ce2c65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff94ce"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.38897 12.447 -11.9282 .39028 13.805 3.736)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4c91ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#a3eaff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#fff",
    rx: 14
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStrEth);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/strETH.84f3862a283310655a5bdbb3f164b726.svg";